import React from 'react';
import { Button, Grid } from '@mui/material';
import {
	HeaderSection,
	ItemText,
	setColorStyle,
	SubtitleItemText,
} from './BiasInfo';
import {
	justCentered,
	columnStyle,
	whichStatus,
	whichTypeOfPacking,
	whichDivison,
	whichPriority,
	money,
	fillEmptyString,
	canUserSeeMoney,
} from '../../../helpers/utils';
import { useState } from 'react';
import { LinearWithValueLabel } from '../../orders/ProgressBar';
import { formatDateMX, formatDateTimeMX } from '../../../helpers/hours';
import { useSelector } from 'react-redux';

// ORDER & BIAS INFORMATION
export const OrderBiasInfoColumn = ({ bias = null, rowId = 0 }) => {
	// State to controll the view (bias or order)
	const [view, setView] = useState(1);
	const { user } = useSelector(state => state);

	return (
		<Grid
			item
			xs={4}
			style={{
				...setColorStyle('green'),
				height: '100%',
			}}
		>
			{/* BIAS */}
			{bias && (
				<Grid
					container
					style={{
						...setColorStyle('red'),
						// height: '100%',
					}}
				>
					<Grid
						item
						xs={12}
						style={{
							...setColorStyle('blue'),
							padding: '15px',
						}}
					>
						<div style={{ ...justCentered, ...columnStyle }}>
							<HeaderSection
								text={`Información de la ${
									view === 1 ? 'partida' : 'orden'
								}`}
							/>

							<Button
								size='small'
								variant='text'
								onClick={() => setView(view === 1 ? 2 : 1)}
							>
								Ver {view === 1 ? 'Orden' : 'Partida'}
							</Button>
						</div>
						<div
							style={{
								// margin: '10px 0 0 0',
								maxHeight: '74vh',
								overflow: 'scroll',
								overflowX: 'hidden',
								padding: '0 5px',
							}}
						>
							{view === 1 ? (
								<BiasInfo bias={bias} rowId={rowId} user={user} />
							) : (
								<OrderInfo order={bias?.order} user={user} />
							)}
						</div>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
};

const BiasInfo = ({ bias = null, rowId = 0, user = null }) => (
	<>
		{/* Garment */}
		<SubtitleItemText title='Prenda' />
		<ItemText
			subtitle='Nombre'
			text={fillEmptyString(bias?.garment?.name)}
		/>
		<ItemText subtitle='Tipo' text={fillEmptyString(bias?.garment?.type)} />
		{bias?.garment?.description?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${bias?.garment?.description}`}
			/>
		)}

		{/* Variant */}
		<SubtitleItemText title='Variante' />
		<ItemText
			subtitle='Nombre'
			text={fillEmptyString(bias?.variant?.name)}
		/>
		<ItemText
			subtitle='Estilo'
			text={fillEmptyString(bias?.variant?.style)}
		/>

		{/* Fabric */}
		<SubtitleItemText title='Tela' />
		<ItemText
			subtitle='Nombre'
			text={fillEmptyString(bias?.fabric?.name)}
		/>
		<ItemText
			subtitle='Composición'
			text={fillEmptyString(bias?.fabric?.composition)}
		/>
		<ItemText
			subtitle='Color'
			text={fillEmptyString(bias?.fabric?.color)}
		/>

		{/* Variable */}
		<SubtitleItemText title='Variables' />
		{/* <ItemText subtitle='Nombre' text={bias?.variable.name} /> */}
		{bias?.variable?.map((variable, i) => (
			<ItemText
				key={`variable-${i + 1}`}
				subtitle={`Variable (${i + 1})`}
				text={variable?.name}
			/>
		))}

		{/* Embroidery*/}
		<SubtitleItemText title='Bordado' />
		<ItemText
			subtitle='Espalda'
			text={fillEmptyString(bias?.back_embroidery)}
		/>
		<ItemText
			subtitle='Frente'
			text={fillEmptyString(bias?.front_embroidery)}
		/>
		<ItemText
			subtitle='Mangas'
			text={fillEmptyString(bias?.sleeves_embroidery)}
		/>
		<ItemText
			subtitle='Tipo de bordado'
			text={fillEmptyString(bias?.embroidery_type)}
		/>
		<ItemText
			subtitle='Color'
			text={fillEmptyString(bias?.embroidery_color)}
		/>
		{bias?.measures_embroidery?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${fillEmptyString(
					bias?.measures_embroidery
				)}`}
			/>
		)}
		{bias?.notes_embroidery?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${fillEmptyString(
					bias?.notes_embroidery
				)}`}
			/>
		)}

		{/* Stamped */}
		<SubtitleItemText title='Estampado' />
		<ItemText
			subtitle='Espalda'
			text={fillEmptyString(bias?.back_stamped)}
		/>
		<ItemText
			subtitle='Frente'
			text={fillEmptyString(bias?.front_stamped)}
		/>
		<ItemText
			subtitle='Mangas'
			text={fillEmptyString(bias?.sleeves_stamped)}
		/>
		<ItemText
			subtitle='Tipo de tinte'
			text={fillEmptyString(bias?.stamped_type)}
		/>
		<ItemText
			subtitle='Color'
			text={fillEmptyString(bias?.stamped_color)}
		/>
		{bias?.measures_stamped?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${fillEmptyString(
					bias?.measures_stamped
				)}`}
			/>
		)}
		{bias?.notes_stamped?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${fillEmptyString(
					bias?.notes_stamped
				)}`}
			/>
		)}

		{/* Information */}
		<SubtitleItemText title='General' first />
		<ItemText subtitle='Clave' text={fillEmptyString(bias?.key)} />
		<ItemText
			subtitle='Fecha estimada'
			text={formatDateMX(bias?.delivery_forecast)}
		/>
		{/* El progreso de la partida va en la sección de estadísticas */}
		<ItemText subtitle='Estatus' text={whichStatus(bias?.status)} />
		<ItemText subtitle='Progreso' text='' />
		<div
			style={{
				margin: '0 0 10px 0',
				width: '80%',
			}}
		>
			<LinearWithValueLabel progress={bias?.progress} />
		</div>

		<ItemText subtitle='Unidades' text={fillEmptyString(bias?.units)} />
		<ItemText
			subtitle='Precio unitario'
			text={fillEmptyString(canUserSeeMoney(user) ? money(bias?.unit_price) : '$ ----')}
		/>
		<ItemText
			subtitle='Subtotal'
			text={fillEmptyString(money(bias?.subtotal))}
		/>
		<ItemText
			subtitle='Precio total'
			text={fillEmptyString(canUserSeeMoney(user) ? money(bias?.total_price) : '$ ----')}
		/>
		{bias?.description?.length > 0 && (
			<ItemText
				subtitle='Descripción'
				text={`Partida #${rowId}: ${fillEmptyString(
					bias?.description
				)}`}
			/>
		)}
		{bias?.observations?.length > 0 && (
			<ItemText
				subtitle='Observaciones'
				text={fillEmptyString(bias?.observations)}
			/>
		)}

		{/* Created by */}
		<SubtitleItemText title='Creado por' />
		<ItemText
			subtitle='Nombre'
			text={`${bias?.created_by?.first_name} ${bias?.created_by?.last_name}`}
		/>
		<ItemText
			subtitle='Correo'
			text={fillEmptyString(bias?.created_by?.email)}
		/>
		{bias?.created_by?.area && (
			<ItemText
				subtitle='Área'
				text={fillEmptyString(bias?.created_by?.area?.name)}
			/>
		)}

		{/* Record */}
		<SubtitleItemText title='Historial' />
		<ItemText
			subtitle='Creado'
			text={fillEmptyString(formatDateTimeMX(bias?.created_at))}
		/>
		<ItemText
			subtitle='Editado'
			text={fillEmptyString(formatDateTimeMX(bias?.updated_at))}
		/>
	</>
);

const OrderInfo = ({ order = null, user = null }) => (
	<>
		{/* Information */}
		<SubtitleItemText title='General' first />
		<ItemText
			subtitle='Número de orden'
			text={fillEmptyString(order?.number_order)}
		/>
		<ItemText
			subtitle='Tipo de empaque'
			text={whichTypeOfPacking(order?.type_of_packing)}
		/>
		<ItemText
			subtitle='Tipo'
			text={order?.type === 'ORD' ? 'Orden' : 'Cotización'}
		/>
		<ItemText subtitle='Importe' text={canUserSeeMoney(user) ? fillEmptyString(order?.amount) : '$ ----'} />
		<ItemText
			subtitle='División'
			text={fillEmptyString(whichDivison(order?.division))}
		/>

		{/* Dates */}
		<SubtitleItemText title='Fechas' />
		<ItemText
			subtitle='Fecha de entrada'
			text={formatDateMX(order?.entry_date)}
		/>
		<ItemText
			subtitle='Fecha de entrega'
			text={formatDateMX(order?.delivery_date)}
		/>
		<ItemText
			subtitle='Fecha estimada'
			text={formatDateMX(order?.delivery_forecast)}
		/>

		{/* Status */}
		<SubtitleItemText title='Avances' />
		<ItemText subtitle='Prioridad' text={whichPriority(order?.priority)} />
		<ItemText subtitle='Estatus' text={whichStatus(order?.status)} />
		<ItemText subtitle='Progreso' text='' />
		<div
			style={{
				margin: '0 0 10px 0',
				width: '80%',
			}}
		>
			<LinearWithValueLabel progress={order?.progress} />
		</div>

		{/* Client */}
		<SubtitleItemText title='Cliente' />
		<ItemText
			subtitle='Razón social'
			text={fillEmptyString(order?.client_id?.company_name)}
		/>
		<ItemText
			subtitle='División'
			text={fillEmptyString(order?.client_id?.division)}
		/>
		<ItemText
			subtitle='Asesor'
			text={fillEmptyString(order?.client_id?.consultant)}
		/>
		<ItemText
			subtitle='RFC'
			text={fillEmptyString(order?.client_id?.rfc)}
		/>

		{/* Created by */}
		<SubtitleItemText title='Creado por' />
		<ItemText
			subtitle='Nombre'
			text={`${order?.created_by?.first_name} ${order?.created_by?.last_name}`}
		/>
		<ItemText
			subtitle='Correo'
			text={fillEmptyString(order?.created_by?.email)}
		/>
		{order?.created_by.area && (
			<ItemText
				subtitle='Área'
				text={fillEmptyString(order?.created_by.area?.name)}
			/>
		)}

		{/* Record */}
		<SubtitleItemText title='Historial' />
		<ItemText
			subtitle='Creado'
			text={formatDateTimeMX(order?.created_at)}
		/>
		<ItemText
			subtitle='Editado'
			text={formatDateTimeMX(order?.updated_at)}
		/>
	</>
);
